import { FunctionComponent } from "react";
import "./GlobalSpinner.css"

interface GlobalSpinnerProps {
    isShow?: Boolean
}

export const Spinner: FunctionComponent = () => {
    return <div className="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
}

const GlobalSpinner: FunctionComponent<GlobalSpinnerProps> = (props) => {

    let {isShow} = props;
    
    return (
        <div className={`spinner-layout ${isShow  ? 'show' : ''}`}>
            {isShow && <Spinner />}
        </div>
    );
}

export default GlobalSpinner;